import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { compileSvgString } from '../utils/compileSvgString';
/**
 * Component that renders compiled template to the DOM
 *
 * * first need to compile template using {@link compileSvgString} hook
 * * to render not-compiled template - use {@link BadgeTemplatePreview} component
 */
export const BadgeTemplateFinalSvgPreview = ({ badgeTemplateFinalSvg, badgeTemplateSvgError, sx, }) => {
    const [compiledSvg, setCompiledSvg] = React.useState('');
    const [compileSvgError, setCompileSvgError] = React.useState('');
    React.useEffect(() => {
        if (!badgeTemplateFinalSvg) {
            setCompiledSvg('');
            return;
        }
        const compileSvgResult = compileSvgString(badgeTemplateFinalSvg);
        if (compileSvgResult.success) {
            setCompiledSvg(compileSvgResult.compiledSvg);
            setCompileSvgError('');
        }
        else {
            setCompiledSvg('');
            setCompileSvgError(compileSvgResult.error);
        }
    }, [badgeTemplateFinalSvg]);
    if (badgeTemplateSvgError || compileSvgError || !compiledSvg) {
        return (React.createElement(Box, { sx: Object.assign({ width: '100%', aspectRatio: '270/428' }, sx) },
            badgeTemplateSvgError && (React.createElement(Typography, { variant: 'body2', color: themeColors.secondary.border }, badgeTemplateSvgError)),
            compileSvgError && (React.createElement(Typography, { variant: 'body2', color: themeColors.secondary.border }, compileSvgError))));
    }
    return (React.createElement(Box, { sx: sx },
        React.createElement("img", { src: `data:image/svg+xml;base64,${compiledSvg}`, alt: 'Badge Preview', style: { width: '100%', height: 'auto' } })));
};
